// extracted by mini-css-extract-plugin
export default {"root":"lujbM","price":"IUBqD","originalPrice":"MTF_b"};